import arrayPush from "./component-library440.mjs";
import getPrototype from "./component-library375.mjs";
import getSymbols from "./component-library360.mjs";
import stubArray from "./component-library429.mjs";
var nativeGetSymbols = Object.getOwnPropertySymbols;
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};
const getSymbolsIn$1 = getSymbolsIn;
export {
  getSymbolsIn$1 as default
};
